module.exports = __webpack_public_path__ + "img/jigsawPuzzle_1.cee18764.png";